import {
  Center,
  Heading,
  Image,
  Spacer,
  ScrollView,
  StatusBar,
  Text,
} from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import imageWallet from '../../../../assets/images/wallet.png';
import moneyDisplay from '../../../helpers/moneyDisplay';
import ActionButton from '../../../shared/ActionButton';
import FacesDisplay from '../../../shared/FacesDisplay';

function ViewWallet({ onEdit, walletContent, walletTotal }) {
  return walletTotal ? (
    <>
      <StatusBar backgroundColor="#F4F8FB" barStyle="dark-content" />
      <Center bg="#F4F8FB" shadow="3" px="4" py="4">
        <Heading size="sm">Votre portefeuille contient</Heading>
        <Heading size="2xl">{moneyDisplay(walletTotal)}</Heading>
      </Center>
      <Center bg="#caf0f8" px="4" py="2">
        <Text>Contenu de votre portefeuille.</Text>
      </Center>
      <ScrollView px="4">
        <FacesDisplay content={walletContent} />
      </ScrollView>
      <ActionButton onPress={onEdit}>Gérer l'argent</ActionButton>
    </>
  ) : (
    <>
      <StatusBar backgroundColor="#ffffff" barStyle="dark-content" />
      <Spacer />
      <Center px="4">
        <Image source={imageWallet} alt="NA" size="300" />
        <Heading textAlign="center">Votre portefeuille est vide !</Heading>
      </Center>
      <Spacer />
      <ActionButton onPress={onEdit}>Ajouter de l'argent</ActionButton>
    </>
  );
}

ViewWallet.propTypes = {
  onEdit: PropTypes.func.isRequired,
  walletContent: PropTypes.array.isRequired,
  walletTotal: PropTypes.number.isRequired,
};

export default ViewWallet;
